import { render, staticRenderFns } from "./default.vue?vue&type=template&id=5c00ede1"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=5c00ede1&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@5.2.7_webpack@4.47.0___3aa45358577dd566fcc66441f4bfb966/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('/opt/atlassian/pipelines/agent/build/components/core/loader.vue').default,MatchCheckin: require('/opt/atlassian/pipelines/agent/build/components/match/match-checkin.vue').default,MatchFoundModal: require('/opt/atlassian/pipelines/agent/build/components/modals/match-found-modal.vue').default,StartWarModal: require('/opt/atlassian/pipelines/agent/build/components/modals/start-war-modal.vue').default,SelectFivePlayersForQueueModal: require('/opt/atlassian/pipelines/agent/build/components/modals/select-five-players-for-queue-modal.vue').default,SegmentCheckInModal: require('/opt/atlassian/pipelines/agent/build/components/modals/segment-check-in-modal.vue').default})
